import { render, staticRenderFns } from "./StartPack.vue?vue&type=template&id=6cb866b5&scoped=true&"
import script from "./StartPack.vue?vue&type=script&lang=js&"
export * from "./StartPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb866b5",
  null
  
)

export default component.exports